import { render, staticRenderFns } from "./SensitivityPage.vue?vue&type=template&id=71c72df9&scoped=true"
import script from "./SensitivityPage.vue?vue&type=script&lang=ts"
export * from "./SensitivityPage.vue?vue&type=script&lang=ts"
import style0 from "./SensitivityPage.vue?vue&type=style&index=0&id=71c72df9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c72df9",
  null
  
)

export default component.exports